import { responsiveConstant } from '@app/Dashboard/constants';
import MobileDashboard from './components/MobileDashboard';
import WebDashboard from './components/WebDashboard';

const Dashboard = () => {
  const width = window.innerWidth;

  return (
    <div>
      {width > responsiveConstant ? <WebDashboard /> : <MobileDashboard />}
    </div>
  );
};

export default Dashboard;
